import { useState, useEffect } from 'react';

/**
 * Returns true if the Apple Sign In SDK is loaded, false otherwise.
 * The SDK is loaded dynamically, so this can be used to wait for the SDK to load before performing actions that require it.
 * @returns {boolean} true if the Apple Sign In SDK is loaded, false otherwise.
 */
export function useAppleSDK() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        // If already loaded, skip
        if (document.getElementById('apple-signin-sdk')) {
            setLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.id = 'apple-signin-sdk';
        script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        script.async = true;
        script.defer = true;
        script.onload = () => setLoaded(true);

        document.body.appendChild(script);
    }, []);

    return loaded;
}
